import React, { memo, Fragment, useEffect } from "react";
import { useRowSelect, useTable } from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _, { isArray } from "lodash";
import classNames from "classnames";
import { format } from "date-fns";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import "react-toastify/dist/ReactToastify.css";
import numeral from "numeral";
import Skeleton from "react-loading-skeleton";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { useState } from "react";
import { Auth } from "aws-amplify";
import { EmitterStatus } from "../../../event";
import { getStyleStatus } from "../utils/leasing.u";
import FootageRequestModal from "components/Leasing/footage/leasing.f.requestModal";
import IndeterminateCheckbox from "../components/leasing.c.indeterminateCheckbox";
import API from "../api/api.main";

const Row = ({ row, i, value, refetch, query, isTransfer }) => {
  const params = useParams();

  const [openModal, setOpenModal] = useState(false);
  const [prevForm, setPrevForm] = useState(null);

  const onClickRoute = () => {
    setOpenModal(true);
  };

  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        onClick={onClickRoute}
        className={classNames(
          "cursor-pointer hover:bg-blue-100 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-50": i % 2 !== 0,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 text-xs text-center"}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
      {openModal && (
        <FootageRequestModal
          isTransfer={isTransfer}
          query={query}
          leasing_request={row?.original}
          openModal={openModal}
          setOpenModal={setOpenModal}
          refetch={refetch}
          prevForm={prevForm}
          setPrevForm={setPrevForm}
        />
      )}
      {/**/}
    </Fragment>
  );
};

function FootageRequestTableMain({
  loading = false,
  leasings = [],
  query,
  setLeasings,
  refetch,
  selectedRows,
  setSelectedRows,
  isTransfer,
}) {
  const columns = useMemo(() => {
    return [
      // {
      //   Header: "No.",
      //   accessor: "no.",
      //   Cell: ({ row }) => {
      //     return <div>{row?.index + 1}</div>;
      //   },
      // },
      {
        Header: "Job No.",
        accessor: "request_id",
      },
      {
        Header: "ชื่อ",
        accessor: "fullname",
      },
      {
        Header: "จำนวนงวด",
        accessor: "period",
      },
      {
        Header: "ประเภทสินเชื่อ",
        accessor: "purpose",
      },
      {
        Header: "วงเงินที่ขอ",
        accessor: "amount",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.amount).format("0,0")}</div>;
        },
      },
      {
        Header: "เบอร์โทร",
        accessor: "phone_number",
      },
      {
        Header: "สถานะ",
        accessor: "loan_status",
        Cell: ({ row }) => {
          const { loan_status } = row.values;
          return (
            <div className={classNames(getStyleStatus(loan_status))}>
              {loan_status}
            </div>
          );
        },
      },
      {
        Header: "จองโดย",
        accessor: "reserveBy",
      },
      {
        Header: "วันที่สร้าง",
        accessor: "createdAt",
        Cell: ({ row }) => {
          return (
            <div>
              {format(new Date(row.values.createdAt), "dd-MM-yyyy HH:mm")}
            </div>
          );
        },
      },
      {
        Header: "วันที่แก้ไข",
        accessor: "updatedAt",
        Cell: ({ row }) => {
          if (row.values?.updatedAt === "-") return <div>-</div>;
          return (
            <div>
              {format(new Date(row.values.updatedAt), "dd-MM-yyyy HH:mm")}
            </div>
          );
        },
      },
    ];
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable({ columns, data: leasings }, useRowSelect, (hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: "selection",
        Header: ({
          flatRows,
          getToggleAllRowsSelectedProps,
          toggleRowSelected,
          rows,
          ...props
        }) => {
          const onChangeAll = (e) => {
            flatRows.forEach((row) => {
              const { loan_status, fileBuro } = row.original;
              toggleRowSelected(row.id, e.target.checked);
            });
          };

          return (
            <div>
              <IndeterminateCheckbox
                onChange={onChangeAll}
                flatRows={flatRows}
                id="ALL"
              />
            </div>
          );
        },
        Cell: ({
          row,
          toggleRowSelected,
          selectedFlatRows,
          flatRows,
          ...props
        }) => {
          const loan_status = row.original.loan_status;
          const fileBuro = row.original.fileBuro;

          return (
            <div className="pointer-events-auto cursor-pointer">
              <IndeterminateCheckbox
                selectedFlatRows={selectedFlatRows}
                flatRows={flatRows}
                onClick={(e) => e.stopPropagation()}
                {...row.getToggleRowSelectedProps()}
              />
            </div>
          );
        },
      },
      ...columns,
    ]);
  });

  useEffect(() => {
    setSelectedRows(selectedFlatRows);
  }, [selectedFlatRows]);

  if (loading)
    return (
      <div className="bg-white rounded p-4 border-blue-400 w-full overflow-x-auto ">
        <Skeleton height={30} count={10} />;
      </div>
    );

  return (
    <div className="bg-white rounded  border-blue-400 w-full overflow-x-auto ">
      <table {...getTableProps()} className="w-full whitespace-no-wrap">
        <thead className=" text-xs font-semibold tracking-wide text-gray-500 border-blue-400  border-b dark:border-gray-700 bg-white dark:text-gray-400 dark:bg-gray-800">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th
                  {...column.getHeaderProps()}
                  className={classNames(
                    "px-4 py-3 text-blue-500 text-center text-xs",
                    {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    }
                  )}
                >
                  {column.render("Header")}
                  <span>
                    {" "}
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <FontAwesomeIcon icon={faAngleDown} />
                      ) : (
                        <FontAwesomeIcon icon={faAngleUp} />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody
          className="bg-white  dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
          {...getTableBodyProps()}
        >
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <Row
                key={i}
                i={i}
                row={row}
                value={leasings[i]}
                query={query}
                refetch={refetch}
                isTransfer={isTransfer}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default FootageRequestTableMain;
